export const setAction = (type, payload) => ({ type, payload });
